const orgsWithPreRecruiting = [
    // Vipps
    'org-9sei34lxz',
    // Origio
    'org-f7gekv5vb',
    // aidn
    'org-pr5m6tdl2c',
    // kvikna
    'org-uug7jnkn5q',
    // Company in test for us to test
    'org-p3yyu9a61t',
    // 'org-cr2lc00sn8',
];

export function getHasEnabledPreRecruiting(orgId: string) {
    return orgsWithPreRecruiting.includes(orgId);
}

const orgsWithPadding = [
    'org-q7ilncme09',
    'org-1nwebf7ss4',
    'org-03yg42cuyi',
    'org-k4pvuasevc',
    'org-5l1n1w4zwp',
    'org-f7gekv5vb',
    'org-fw7nfx9qpi',
    'org-lzqqelep8',
    'org-9sei34lxz',
    'org-medisztoi6',
    'org-56d1e8104g',
    'org-i8chn0ieec',
    'org-504wulktf8',
    'org-pr5m6tdl2c',
    'org-6oy9sooc6d',
    'org-0etjcfckrq',
];

export function getHasPaddingEnabled(orgId: string) {
    return orgsWithPadding.includes(orgId);
}
